
import React, {useContext, useState} from 'react';
import styled from 'styled-components';
import { GlobalContext } from '../contexts/GlobalContext';

import {Button} from 'semantic-ui-react';

import ViewAsToggleComponent from '../components/ViewAsToggleComponent';


const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 110px;
    margin-left: 60px;
    margin-right: 60px;

    @media screen and (max-width: 425px) {
        margin-left: 19px;
        margin-right: 19px;
    }
`;

const HeaderText = styled.text`
    font-family: Poppins;
    font-size: 18px;

    @media screen and (max-width: 768px) {
        display: none;
    }

    @media screen and (max-width: 425px) {
        display: none;
    }
`;


const QualificationDiv = styled.div`
    align-items: center;
    display: flex;
    height: 74px;
    justify-content: space-between;
    outline: 1px solid #E2E2E2;
`;

const QualificationInfoDiv = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;

    @media screen and (max-width: 768px) {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
`;

const QualificationName = styled.text`
    color: #464646;
    font-family: Poppins;
    font-size: 14;
    margin-left: 60px;
    min-width: 340px;
    width: 340px;
    // padding-right: 285px;

    @media screen and (max-width: 768px) {
        min-width: unset;
        width: auto;
        padding-right: 0px;
        // padding-right: 180px;
    }

    @media screen and (max-width: 425px) {
        margin-left: 19px;
    }

    @media screen and (max-width: 320px) {
        // padding-right: 80px;
    }
`;

const QualificationDescription = styled.text`
    color: #464646;
    font-family: Poppins;
    font-size: 14;
    width: 100%;

    @media screen and (max-width: 768px) {
        min-width: unset;
        margin-right: 80px;
        text-align: right;
    }

    @media screen and (max-width: 425px) {
        margin-right: 10px;
    }
`;

const QualificationButtonsDiv = styled.div`
    display: flex;

    margin-right: 60px;

    @media screen and (max-width: 768px) {
        display: none;
    }

    @media screen and (max-width: 425px) {
        display: none;
    }
`;

const QualificationButtonsMobileDiv = styled.div`
    margin-right: 19px;
    display: none;

    @media screen and (max-width: 768px) {
        margin-right: 60px;
         display: block;
    }

    @media screen and (max-width: 425px) {
        margin-right: 19px;
         display: block;
    }
`;

const AddQualificationButton = styled.button`
    color: #fff;
    background: rgba(29, 89, 155, 1);
    border-radius: 9px;
    width: 177px;
    height: 44px;
    border: none;

    :hover {
        background: rgba(29, 89, 155, 0.8);
        cursor: pointer;
    }
`;

const LabelDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 60px;
    margin-right: 60px;

    @media screen and (max-width: 425px) {
        margin-left: 19px;
    }
    
`;

const LabelInfoDiv = styled.div`
    padding-top: 80px;
    padding-bottom: 26px;

    @media screen and (max-width: 768px) {
        padding-right: 120px;
        padding-top: 0px;
        padding-bottom: 0px;
        display: flex;
        justify-content: space-between;
        width: 100%;
        min-width: unset;
    }

    @media screen and (max-width: 425px) {
        padding-right: 0px;
        padding-top: 0px;
        padding-bottom: 0px;
        display: flex;
        justify-content: space-between;
        width: 100%;
        min-width: unset;
    }
`;

const LabelText = styled.text`
    color: #595959;
    font-weight: 600;
    font-family: Poppins;
    font-size: 14px;
    text-transform: uppercase;
    padding-top: 80px;
    padding-bottom: 26px;
`;

const LabelNameText = styled.text`
    color: #595959;
    font-weight: 600;
    font-family: Poppins;
    font-size: 14px;
    text-transform: uppercase;
    padding-top: 80px;
    padding-bottom: 26px;
    padding-right: 300px;

    @media screen and (max-width: 768px) {
         padding-right: 0px;
    }

    @media screen and (max-width: 425px) {
        padding-right: 0px;
        // padding-right: 190px;
    }

    @media screen and (max-width: 320px) {
        padding-right: 0px;
    }
`;


const Qualification = (props)  => {
    return (
        <QualificationDiv aria-label={`qualification ${props.name}`}>
            <QualificationInfoDiv>
                <QualificationName>{props.name}</QualificationName>
                <QualificationDescription><span>{props.description}</span></QualificationDescription>
            </QualificationInfoDiv>
            <QualificationButtonsDiv>
                <Button aria-label={`Edit ${props.name}'s details`} color='blue' onClick={props.editQualificationCallback}>Edit</Button><Button aria-label={`Delete ${props.name} qualification`} basic onClick={props.confirmDeleteCallback}>Delete</Button>
            </QualificationButtonsDiv>
            <QualificationButtonsMobileDiv>
                <Button aria-label={`Edit ${props.name}'s details`} className='ui icon button' onClick={props.editQualificationCallback}><i className='ellipsis vertical icon'></i></Button>
            </QualificationButtonsMobileDiv>
        </QualificationDiv>
    );
}



const QualificationsPage = (props) => {

    const [state, setState] = useContext(GlobalContext);

    const [viewMode, setViewMode] = useState('List');

    const handleViewMode = (mode) => {
        if (mode == 'list') {
            setViewMode('List');
        }
        else if (mode == 'grid') {
            setViewMode('Grid');
        }
    }

    return (
        props.active === 'qualifications' ? (
        <React.Fragment>
            <HeaderDiv>
                <HeaderText>{ state['qualifications'] ? state['qualifications'].length : 0 } Qualifications</HeaderText>
                <AddQualificationButton onClick={props.addQualificationCb}>Add Qualification</AddQualificationButton>
                {/* <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    <HeaderText>View as {viewMode}</HeaderText>
                    <ViewAsToggleComponent handleClick={handleViewMode} />
                </div> */}
            </HeaderDiv>
            <LabelDiv>
                <LabelInfoDiv><LabelNameText>Name</LabelNameText><LabelText>Description</LabelText></LabelInfoDiv>
            </LabelDiv>

            {
            state['qualifications'] ?
                state['qualifications'].map(qualification => (
                    <Qualification name={qualification.name} description={qualification.description} 
                     confirmDeleteCallback={props.confirmDeleteCb('qualification', 'Delete Qualification', ' qualification?',qualification.name, qualification.id)}
                     editQualificationCallback={
                        props.editQualificationCb(qualification.name, qualification.id, qualification.description, state['employees']?.filter( e => e.qualifications.some( f => f.id === qualification.id)) )
                    }
                    />
                )) : <p>No qualifications</p>
            }

        </React.Fragment>
        ) : <React.Fragment></React.Fragment>
    );
}

export default QualificationsPage;